var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrdemServico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 2.82971H4.14901C3.41887 2.82971 2.82812 3.4271 2.82812 4.15723L2.83476 13.4499C2.83476 14.18 3.42551 14.7774 4.15565 14.7774H10.6897C10.756 14.7774 10.8196 14.7511 10.8665 14.7042L14.7026 10.8681C14.7495 10.8212 14.7758 10.7576 14.7758 10.6913V4.15723C14.7758 3.4271 14.1784 2.82971 13.4483 2.82971ZM5.48317 6.81228C5.48317 6.44569 5.78035 6.14852 6.14693 6.14852H11.457C11.8236 6.14852 12.1208 6.44569 12.1208 6.81228V6.81228C12.1208 7.17887 11.8236 7.47604 11.457 7.47604H6.14693C5.78035 7.47604 5.48317 7.17887 5.48317 6.81228V6.81228ZM8.80198 9.46733C8.80198 9.83391 8.5048 10.1311 8.13822 10.1311H6.14693C5.78035 10.1311 5.48317 9.83391 5.48317 9.46733V9.46733C5.48317 9.10074 5.78035 8.80356 6.14693 8.80356H8.13822C8.5048 8.80356 8.80198 9.10074 8.80198 9.46733V9.46733ZM10.5563 13.355C10.3988 13.5125 10.1295 13.4009 10.1295 13.1782V11.1311C10.1295 10.5788 10.5772 10.1311 11.1295 10.1311H13.1766C13.3994 10.1311 13.5109 10.4004 13.3534 10.5579L10.5563 13.355Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrdemServico);
export default __webpack_public_path__ + "static/media/IconOrdemServico.81b7a9d86f3f1ed90c78426a692c3cb0.svg";
export { ForwardRef as ReactComponent };